import { useLocalization } from '@/Hooks';

export const useRequired = (isRequired = true) => {
  const { validation } = useLocalization();

  return { required: { value: isRequired, message: validation.Required } };
};
